import type Vue from 'vue'

import { useSweetAlert } from '@/common/composables/sweet-alert'
import type { ErrorHandler } from '@/common/lib/error-handlers/error-handler'

/**
 * Handle all other errors, that we treat as undefined.
 * It may be not HTTP code that is not handled by any other case,
 * or error that does not come from HTTP.
 */
const handleUndefinedError: ErrorHandler = async (vue: Vue): Promise<void> => {
    const { showToast } = useSweetAlert()

    await showToast(vue.$t('errors.undefined').toString(), 'error')
}

export { handleUndefinedError }
